import {CURRENT_SEASON} from "../config";
import {padStart} from "lodash";

export const nextInvoiceNumber = (sequence: {prefix: string, nextValue: number}) =>
  `${sequence.prefix}${CURRENT_SEASON.substring(0, 4)}-${(padStart(`${sequence.nextValue}`, 4, '0'))}`
